import CommonMemberTable from "../commonModule/CommonMemberTable";

const RejectedMemberTable = () => {
  return <CommonMemberTable status="rejected" title="Rejected Members" />;
};

export default RejectedMemberTable;
